import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 14, viewBox: "0 0 11 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0V14L11 7L0 0Z", fill: "#0062CC" }));
export default SvgPlay;
